import React from 'react';

interface StatCardProps {
  icon: React.ElementType;
  value: string | number;
  label: string;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
}

const StatCard: React.FC<StatCardProps> = ({ 
  icon: Icon, 
  value, 
  label, 
  color = 'border-blue-500',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  
  const valueSizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl'
  };
  
  return (
    <div className={`bg-white border-l-4 ${color} rounded-lg shadow-md ${sizeClasses[size]}`}>
      <div className="flex items-center">
        <div className={`p-3 rounded-full ${color.replace('border-', 'bg-')} bg-opacity-10`}>
          <Icon className={`h-6 w-6 ${color.replace('border-', 'text-')}`} />
        </div>
        <div className="ml-4">
          <p className="text-gray-500 text-sm font-medium">{label}</p>
          <p className={`${valueSizeClasses[size]} font-semibold`}>{value}</p>
        </div>
      </div>
    </div>
  );
};

export default StatCard; 